module.exports = __webpack_public_path__ + "media/country_flags/bf-fde1382e.png";